import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { HttpError, type CardDetail } from '@voll-intelligence/domain';

import { queryKeys } from '@web/core/query';
import { boardRepository } from '@web/data/repositories';
import { useOrgContext } from '@web/ui/core/hooks';

function isClientError(err: unknown): boolean {
  return err instanceof HttpError && err.status >= 400 && err.status < 500;
}

/**
 * The card of the conversation the page is about, read by conversation — the
 * route every org member opens, guests outside the card's squad included
 * (`GET /cards/:cardId` would 403 them). A 4xx is a final answer (404 = this
 * conversation has no card); anything else gets one immediate retry.
 */
export function useConversationCard(conversationId: string): UseQueryResult<CardDetail> {
  const { orgId } = useOrgContext();
  return useQuery({
    queryKey: queryKeys.cards.byConversation(orgId, conversationId),
    queryFn: () => boardRepository.findCardByConversation(orgId, conversationId),
    enabled: conversationId !== '',
    retry: (count, err) => !isClientError(err) && count < 1,
    retryDelay: 0,
    meta: { silent: true },
  });
}
